export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCT = "GET_PRODUCT";
export const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE";
export const SET_PAGER = "SET_PAGER";
export const SET_PAGE_Size = "SET_PAGE_Size";
export const GET_GROUPS = "GET_GROUPS";
export const GET_FEATURED_PRODUCTS = "GET_FEATURED_PRODUCTS";
export const GET_RECOMMENDED_PRODUCTS = "GET_RECOMMENDED_PRODUCTS";
export const GET_RELATED_PRODUCTS = "GET_RELATED_PRODUCTS";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const UPDATE_CART = "UPDATE_CART";
export const EMPTY_CART = "EMPTY_CART";

export const EMPTY_WISHLIST = "EMPTY_WISHLIST";
export const GET_ACTIVE_SETTINGS = "GET_ACTIVE_SETTINGS";
export const GET_SITE_LINKS = "GET_SITE_LINKS";
export const GET_REPRESENTATIVES = "GET_REPRESENTATIVES";

export const GET_ACTIVE_PROMOTIONS = "GET_ACTIVE_PROMOTIONS";
export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const SAVE_PROFILE = "SAVE_PROFILE";
export const SAVE_GUEST_PROFILE = "SAVE_GUEST_PROFILE";

export const CHECK_CUSTOMER_EXISTS = "CHECK_CUSTOMER_EXISTS";
export const RESET_CHECK_CUSTOMER_EXISTS = "RESET_CHECK_CUSTOMER_EXISTS";

export const LOGOUT = "LOGOUT";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const CHECK_SESSION = "CHECK_SESSION";
export const GET_ACTIVE_SLIDER_ITEMS = "GET_ACTIVE_SLIDER_Items";
export const GET_ORDERS = "GET_ORDERS";
export const GET_ORDER = "GET_ORDER";
export const CLEAR_ORDER = "CLEAR_ORDER";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const GENERATE_STOCK_WITH_PRICE = `GENERATE_STOCK_WITH_PRICE`;
export const RESET_SELECTED_STOCK = `RESET_SELECTED_STOCK`;

export const RESET_PASSWORD_CLEAR = "RESET_PASSWORD_CLEAR";

export const NEWSLETTER_SUBSCRIBE = "NEWSLETTER_SUBSCRIBE";

export const CHECKOUT = "CHECKOUT";
export const ORDER_CHECKOUT = "ORDER_CHECKOUT";
export const BUILD_CHECKOUT_SALE = "BUILD_CHECKOUT_SALE";
export const STORE_LOCAL_SALE = "STORE_LOCAL_SALE";
export const CLEAR_LOCAL_SALE = "CLEAR_LOCAL_SALE";
 
export const AUTHORIZE_PAYMENT = "AUTHORIZE_PAYMENT";

export const CANCEL_EXTERNAL_REDIRECT = "CANCEL_EXTERNAL_REDIRECT";

export const GET_PAGE = "GET_PAGE";
export const INIT_CATALOGUE = "INIT_CATALOGUE";

export const CONTACT_REP = "CONTACT_REP";
export const SHARE_BY_EMAIL = "SHARE_BY_EMAIL";


export const CREATE_OPENPAY_ORDER = "CREATE_OPENPAY_ORDER";
export const OPENPAY_GET_STATUS = "OPENPAY_GET_STATUS";
export const OPENPAY_LOG_CALLBACK = "OPENPAY_LOG_CALLBACK";
export const SAVE_OPENPAY_PLAN = "SAVE_OPENPAY_PLAN";
export const RESET_OPENPAY_PLAN = "RESET_OPENPAY_PLAN";

export const GET_CARTS = `GET_CARTS`;
export const GET_CART = `GET_CART`;
export const SET_CART = `SET_CART`;
export const LOAD_CART_BY_URL = `LOAD_CART_BY_URL`;
export const SAVE_CART = `SAVE_CART`;
export const REMOVE_CART = `REMOVE_CART`;

export const GET_CUSTOMER_REFERRALS = `GET_CUSTOMER_REFERRALS`;
export const GET_CUSTOMER_REFERRAL_CODE = `GET_CUSTOMER_REFERRAL_CODE`;
export const CREATE_CUSTOMER_REFRRAL_CODE = `CREATE_CUSTOMER_REFR`;

export const GET_NEARBY_CONSULTANTS = `GET_NEARBY_CONSULTANTS`;
export const SET_CONSULTANT_DATA = `SET_CONSULTANT_DATA`;

export const CREATE_STRIPE_CARD_TOKEN = `CREATE_STRIPE_CARD_TOKEN`;

export const GET_TRANSLATIONS = `GET_TRANSLATIONS`;

export const SHOW_LOADING_BAR = `loading-bar/SHOW`;
export const HIDE_LOADING_BAR = `loading-bar/HIDE`;

// export const GET_USER_INFO = "GET_USER_INFO";
// redux-promise-middleware messages
export const FULFILLED = "_FULFILLED";
export const REJECTED = "_REJECTED";
export const PENDING = "_PENDING";
